// extracted by css-extract-rspack-plugin
export default {"tokenField":"RecipientPicker-module__tokenField___rj1CI"};